import * as S from './PopupHeader.styles'

type Props = {
  title: string
  leftButton: React.ReactNode
  rightButton: React.ReactNode
  sticky?: boolean
}

/**
 * @example The simplest way to use the headers in popups
 * <PopupHeader title='Add Address'>
 */
export default function PopupHeader({
  title,
  leftButton,
  rightButton,
  sticky,
}: Props) {
  return (
    <S.Container $sticky={sticky}>
      <S.MenuStrip>
        <S.ButtonContainer>{leftButton}</S.ButtonContainer>
        <S.Title>{title}</S.Title>
        <S.ButtonContainer>{rightButton}</S.ButtonContainer>
      </S.MenuStrip>
    </S.Container>
  )
}
